import CheckboxElement from "components/Elements/CheckboxElement/CheckboxElement";
import { useCustomController } from "components/Reusable/Form/useCustomController";
import { useContent } from "contexts/contentContext/contentContext";
import { EMAIL_VALIDATOR } from "helpers/validators";
import { useEffect, useState } from "react";

const FavoriteCheckboxField = (props) => {
  const { getTextByKey } = useContent();
  const { fieldControls, setErrorMessage, hasError } =
    useCustomController(props);
  const [favorite, setFavorite] = useState(fieldControls.value);

  useEffect(() => {
    fieldControls.onChange(favorite);
  }, [favorite]);

  const handleSetFavorite = (bool) => {
    if (props.externalProps.countFavoritesUsers === 5 && bool) {
      setErrorMessage(getTextByKey("max-favorites"));
    } else {
      setFavorite(bool);
    }
  };

  useEffect(() => {
    let timeId;
    if (hasError) {
      timeId = setTimeout(() => {
        setErrorMessage(null);
      }, 3000);
    }
    return () => {
      clearTimeout(timeId);
    };
  }, [hasError]);

  return (
    <div className="favorite-container">
      <CheckboxElement
        state={favorite}
        setState={handleSetFavorite}
        checkboxLabel="favorite-contact-label"
        checkboxTooltip="favorite-contact-tooltip"
      />
    </div>
  );
};

const contactFormFields = {
  ContactName: {
    fieldKey: "ContactName",
    element: "input",
    type: "text",
    title: "ContactName",
    label: "signin-firstname-label",
    placeholder: "contactname-placeholder",
  },
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "Email",
    label: "signin-email-label",
    placeholder: "signin-email-placeholder",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
  },
  PhoneNumber: {
    fieldKey: "PhoneNumber",
    element: "input",
    type: "text",
    title: "PhoneNumber",
    label: "phonenumber-label",
    placeholder: "phonenumber-placeholder",
    containerClassName: "input-half-width",
  },
  ContactListFavorite: {
    element: "customelement",
    fieldKey: "ContactListFavorite",
    render: (props) => <FavoriteCheckboxField {...props} />,
  },
};

export default contactFormFields;
